/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function SortIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "sort", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M16.5 19V7", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M8.5 18V6", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12 15L8.5 18.5L5 15", stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M13 10L16.5 6.5L20 10", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(SortIcon);
export default ForwardRef;
//# sourceMappingURL=sortIcon.js.map